import {
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD,
  ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT,
} from '../../../Entity'

export const QA_NAME_APPLICANT_PROFILE_INFO_FOLLOW_UP = 'applicantInfoFollowUp'

export const QA_NAME_APPLICANT_PROFILE_INFO_RESPONSIBLE_MANAGER =
  'applicantInfoResponsibleManager'

export const QA_NAME_APPLICANT_PROFILE_INFO_RESPONSIBLE_MANAGER_ADD =
  'applicantInfoResponsibleManagerAddBtn'

export const QA_NAME_APPLICANT_PROFILE_INFO_RESPONSIBLE_MANAGER_EDIT =
  'applicantInfoResponsibleManagerEditBtn'

export const QA_NAME_APPLICANT_PROFILE_INFO_PORTAL = 'applicantInfoPortal'

export const QA_NAME_APPLICANT_PROFILE_PHASE_BAR = 'applicantPhaseBar'

export const APPLICANT_PROFILE_HEADER_INFO_ITEMS_COLUMNS = 3

export const APPLICANT_PROFILE_HEADER_INFO_ITEMS_LOADING_LENGTH = 3

export const APPLICANT_PROFILE_INFO_ITEM_ACTION_KEY = {
  add: ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_ADD,
  edit: ENTITY_PROFILE_HEADER_INFO_ITEM_ACTIONS_KEY_EDIT,
}

export const APPLICANT_PROFILE_INFO_ITEM_TITLE_KEY = {
  followUp: 'RentalPortal.ApplicantProfileFollowUpKey',
  portalReceived: 'RentalPortal.ApplicantProfilePortalReceivedLabelKey',
  responsibleManager: 'RentalPortal.ListingProfileResponsibleManagerKey',
}

export const APPLICANT_PHASE_STATE = {
  active: 'active',
  done: 'done',
  upcoming: 'upcoming',
}

export const APPLICANT_PHASE_TERMINAL_REASON = {
  rejected: 'rejected',
  withdrawn: 'withdrawn',
}

export const APPLICANT_PHASE_TERMINAL_STATEMENT_KEY = {
  [APPLICANT_PHASE_TERMINAL_REASON.rejected]:
    'RentalPortal.ApplicantPhaseTerminalRejectedKey',
  [APPLICANT_PHASE_TERMINAL_REASON.withdrawn]:
    'RentalPortal.ApplicantPhaseTerminalWithdrawnKey',
}

export const APPLICANT_FOLLOW_UP_SOON_DAYS = 7

export const APPLICANT_FOLLOW_UP_TEXT_COLOR = {
  future: 'var(--color-success)',
  past: 'var(--color-error)',
  soon: 'var(--color-warning)',
  terminal: 'var(--secondary-text-color)',
}
